import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import LoadingScreen from './LoadingScreen';

const AuthGuard = (props) => {
  const { children } = props;
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();
  const authError = new URLSearchParams(location.search).get('error');
  const authErrorDescription = new URLSearchParams(location.search).get('error_description') || '';
  const isEmailVerificationError = authError === 'access_denied'
    && authErrorDescription.toLowerCase().includes('verify your email');

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (isEmailVerificationError) {
      return (
        <Navigate
          to="/login/?authError=email_not_verified"
          replace
        />
      );
    }

    const returnTo = encodeURIComponent(`${location.pathname}${location.search}${location.hash}`);
    return (
      <Navigate
        to={`/login/?returnTo=${returnTo}`}
        replace
      />
    );
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
